import { Icons } from '@/utils/Icons';
import React from 'react';

const ComponentLoader: React.FC = () => {
  return (
    <div
      className="absolute inset-0 z-50 w-full h-full
        flex items-center justify-center
        bg-white/50"
    >
      <Icons.Loading className="text-4xl animate-spin text-gray-700" />
    </div>
  );
};

export default ComponentLoader;
